import React from 'react';
import './ResetPasswordComponent.less';
import {ButtonPrimary} from '@homeaway/react-buttons';

function ResetPasswordComponent({lingua, updatePage}) {
    function returnToLogin() {
        updatePage('initial');
    }

    return (
        <div className="ResetPassword text-center">
            <div className="Padding">
                <svg width="69px" height="49px" viewBox="0 0 69 49" version="1.1">
                    <g strokeWidth={1} stroke="none" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                        <g transform="translate(-685.000000, -165.000000)" stroke="#5E6D77" strokeWidth={1.5}>
                            <g transform="translate(500.000000, 117.000000)">
                                <g transform="translate(40.000000, 48.000000)">
                                    <g transform="translate(146.000000, 0.000000)">
                                        <path d="M55.1169988,13.3579528 L36.9926758,27.7042882 C35.053595,29.235518 32.3167006,29.2462509 30.366887,27.7329093 L9.25881242,11.3115429 C7.63814161,10.0522137 5.44504845,9.82682236 3.60614161,10.7248099 C1.76365714,11.6263752 0.597346584,13.4974807 0.597346584,15.5438907 L0.597346584,41.8896298 C0.597346584,44.8519155 3.0015205,47.2560894 5.96380621,47.2560894 L66.783682,47.2560894 L66.783682,6.1132323 C66.783682,3.14736894 64.3795081,0.746772671 61.4172224,0.746772671 L0.597346584,0.746772671"/>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
            <div><h2 className="Header">{lingua.read('lex.password.reset.title')}</h2></div>
            <p className="Padding lead">{lingua.read('lex.password.reset.subtitle')}</p>
            <ButtonPrimary label={lingua.read('lex.password.reset.button')} onClick={returnToLogin}/>
        </div>
    );
}

export default ResetPasswordComponent;
